<span class="step-content">
    <table class="table">
        <tbody>
            <ng-container *ngFor="let block of step?.blocks | slice:isCollapsedIndex[0]:isCollapsedIndex[1]; let i = index">
                <ng-container *ngIf="block.type !== stepTypeEnum.Menu">
                    <a class="step step-link" [ngClass]="{'gradient-overlay': isCollapsed && step && step.blocks && step.blocks.length > 3 && i === 2}" >
                        <tr class="block-info"
                        [ngClass]="{'inactive-link': block.enabled}"
                        [routerLink]="!block?.blocks?.length ? getRoutingLink(block) : null"
                        (click)="block?.blocks?.length ? toggleBlock(i) : null">
                            <!--Блок со шкалой/фактом -->
                            <th class="block-column-icon ordinary-text column-1">
                                <!--FACT -->
                                <ng-container *ngIf="block.progress && block.progress?.type === progressTypeEnum.FACT && !(block.showLock || block.parent?.showLock)">
                                    <ng-container *ngIf="block.progress?.mastered == true">
                                        <div class="icon-fact-container">
                                            <mat-icon class="success-mark-icon-step" svgIcon="fact-green-unfilled"></mat-icon>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="block.progress?.mastered == false">
                                        <div class="icon-fact-container">
                                            <mat-icon class="success-mark-icon-step" svgIcon="fact-red-unfilled"></mat-icon>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <!--SCALE -->
                                <ng-container *ngIf="block.progress && block.progress?.type === progressTypeEnum.SCALE && !(block.showLock || block.parent?.showLock)">
                                <ng-container *ngIf="deviceType === 'mobile'">
                                    <app-progress-spinner
                                    class="spinner-value-text"
                                    [color]="'var(--spiner-color-blue)'"
                                    [backgroundColor]="'var(--spiner-color-red)'"
                                    [value]="block.progress.value"
                                    [diametr]="30"
                                    [strokeWidth]="4"
                                    ></app-progress-spinner>
                                    </ng-container>
                                    <ng-container *ngIf="deviceType !== 'mobile'">
                                    <app-progress-spinner
                                    class="spinner-value-text"
                                    [color]="'var(--spiner-color-blue)'"
                                    [backgroundColor]="'var(--spiner-color-red)'"
                                    [value]="block.progress.value"
                                    [diametr]="40"
                                    [strokeWidth]="6"
                                    ></app-progress-spinner>
                                    </ng-container>
                                </ng-container>
                            </th>
                            <!--Блок с текстом -->
                            <th class="block-column-text column-2">
                                <div >
                                    <p class="column-paragraph"
                                    [ngClass]="{
                                        'inactive-text': block?.enabled,
                                        'locked-text': block.showLock || block.parent?.showLock,
                                    }"
                                    class="block-title mat-body-1">{{block?.name}}</p>
                                    <p *ngIf="block?.passed !== null" style="margin: 0;"
                                    class="step-info-text"
                                    [ngClass]="{
                                            'inactive-text': block?.enabled,
                                            'success-text': !block?.enabled && block?.passed,
                                            'alert-text': !block?.enabled && !block?.passed,
                                            'locked-text': block.showLock || block.parent?.showLock,
                                    }"
                                    >{{block?.passed ? 'Зачтено!' : 'Не зачтено'}}</p>
                                    <p *ngIf="block?.progress?.mandatoryOption"
                                    class="step-info-text"
                                    [ngClass]="{
                                        'inactive-text': block?.enabled || block?.passed || block?.progress?.mandatoryOption === mandatoryMasteredOptionEnum.OPTIONAL,
                                        'success-text': !block?.enabled && block?.progress?.mandatoryOption === mandatoryMasteredOptionEnum.RECOMMENDED,
                                        'alert-text': !block?.enabled &&  block?.progress?.mandatoryOption === mandatoryMasteredOptionEnum.REQUIRED,
                                        'locked-text': block.showLock || block.parent?.showLock,

                                    }">{{getMandatoryOptionText(block)}}</p>
                                </div>
                            </th>
                            <!--Блок с таймером -->
                            <th class="block-column-timer column-3">
                                <p class="mat-body-1 timer">01.04.2025  09:00 - 10:00</p>
                            </th>
                            <!--Блок со стрелкой -->
                            <th class="block-column-icon column-4">
                                <div class="menu-tools" *ngIf="block?.blocks?.length">
                                    <mat-icon class="block-toggle-icon" svgIcon="sort-up" *ngIf="openBlocks[i]"
                                    [ngClass]="{'success-mark-icon-locked': block.showLock || block.parent?.showLock}"></mat-icon>
                                    <mat-icon class="block-toggle-icon" svgIcon="sort-down" *ngIf="!openBlocks[i]"
                                    [ngClass]="{'success-mark-icon-locked': block.showLock || block.parent?.showLock}"></mat-icon>
                                </div>
                            </th>
                        </tr>
                        <ng-container *ngIf="openBlocks[i]">
                            <tr class="block-info block-info-sub"
                            *ngFor="let block of block?.blocks"
                            [ngClass]="{'inactive-link': block.enabled}"
                            [routerLink]="getRoutingLink(block)">
                                <!--Блок со шкалой/фактом пусто -->
                                <th class="block-column-icon ordinary-text column-1">
                                </th>
                                <!--Блок с текстом -->
                                <th class="block-column-text column-2">
                                    <div >
                                        <p class="column-paragraph"
                                        [ngClass]="{
                                            'inactive-text': block?.enabled,
                                            'locked-text': block.showLock || block.parent?.showLock,
                                        }"
                                        class="block-title mat-body-1">{{block?.name}}</p>
                                        <p *ngIf="block?.passed !== null" style="margin: 0;"
                                        class="step-info-text"
                                        [ngClass]="{
                                                'inactive-text': block?.enabled,
                                                'success-text': !block?.enabled && block?.passed,
                                                'alert-text': !block?.enabled && !block?.passed,
                                                'locked-text': block.showLock || block.parent?.showLock,
                                        }"
                                        >{{block?.passed ? 'Зачтено!' : 'Не зачтено'}}</p>
                                        <p *ngIf="block?.progress?.mandatoryOption"
                                        class="step-info-text"
                                        [ngClass]="{
                                            'inactive-text': block?.enabled || block?.passed || block?.progress?.mandatoryOption === mandatoryMasteredOptionEnum.OPTIONAL,
                                            'success-text': !block?.enabled && block?.progress?.mandatoryOption === mandatoryMasteredOptionEnum.RECOMMENDED,
                                            'alert-text': !block?.enabled &&  block?.progress?.mandatoryOption === mandatoryMasteredOptionEnum.REQUIRED,
                                            'locked-text': block.showLock || block.parent?.showLock,
                                        }">{{getMandatoryOptionText(block)}}</p>
                                    </div>
                                </th>
                                <!--Блок с таймером -->
                                <th class="block-column-timer column-3">
                                    <p class="mat-body-1 timer">01.04.2025  09:00 - 10:00</p>
                                </th>
                                <!--Блок с галочкой, замком, смайликом -->
                                <th class="block-column-icon column-4">
                                    <ng-container *ngIf="!block.progress?.mastered && (block.showLock || block.parent?.showLock)">
                                        <mat-icon class="block-icon unshrinkable" svgIcon="lock-closed"></mat-icon>
                                    </ng-container>
                                    <ng-container *ngIf="block.showFlag && !(block.showLock || block.parent?.showLock)">
                                        <ng-container *ngIf="block.passed">
                                            <mat-icon class="success-mark-icon" svgIcon="passed" [ngClass]="{'success-mark-icon-locked': block.showLock || block.parent?.showLock}"></mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="!block.passed">
                                            <mat-icon class="success-mark-icon primary-icon" svgIcon="not-passed" [ngClass]="{'success-mark-icon-locked': block.showLock || block.parent?.showLock}"></mat-icon>
                                        </ng-container>
                                    </ng-container>
                                </th>
                            </tr>
                        </ng-container>
                    </a>
                </ng-container>
            </ng-container>
        </tbody>
    </table>
</span>

<ng-container *ngIf="step && step.blocks && step.blocks.length > 3">
    <div class="toggle-container"
        (mousedown)="isPressed = true"
        (mouseup)="isPressed = false"
        (mouseleave)="isPressed = false"
         (click)="toggle()">

       <div class="toggle-top">
           <div class="toggle-top-left"></div>
           <div class="toggle-top-middle"></div>
           <div class="toggle-top-right"></div>
       </div>

       <div class="toggle-bottom">
           <div class="toggle-bottom-top">
               <img src="assets/icons/hide_expand.svg"
                class="icon"
                [ngClass]="{'shadow-effect': isPressed}"
                [class.rotated]="!isCollapsed"
                [ngStyle]="{ 'margin-bottom': !isCollapsed ? '10px' : '5px' }">
           </div>
           <div class="toggle-bottom-bottom"></div>
       </div>
    </div>
</ng-container>

